import { call, put, takeLatest } from "redux-saga/effects";
import { API } from "../api";
import {
  PERSONAL_SHOPPER_LIST_2,
  PERSONAL_SHOPPER_LIST_SUCCESS_2,
  PERSONAL_SHOPPER_LIST_FAIL_2,
  THREAD_USER,
  THREAD_USER_SUCCESS,
  THREAD_USER_FAIL,
  THREAD_CHAT,
  THREAD_CHAT_SUCCESS,
  THREAD_CHAT_SUCCESS_FAIL,
  PERSONAL_SHOPPER_ITEMS_LIST_SUCCESS,
  PERSONAL_SHOPPER_ITEMS_LIST_FAIL,
  PERSONAL_SHOPPER_ITEMS_LIST,
  PERSONAL_SHOPPER_DROP_DOWN_LIST,
  PERSONAL_SHOPPER_DROP_DOWN_LIST_SUCCESS,
  PERSONAL_SHOPPER_DROP_DOWN_LIST_FAIL,
} from "../actions/PersonalShopperActions";

function* personalshopperList(action) {
  try {
    const { onSuccess, ...otherPayload } = action?.payload || {};
    const response = yield call(API.personalShopperItemsListLegacy, otherPayload);
    console.log("saga__1",response)
     yield put({
      type: PERSONAL_SHOPPER_LIST_SUCCESS_2,
      payload: response.data,
    });
    if (typeof onSuccess === "function") {
      onSuccess();
    }
   
  } catch (error) {
    yield put({
      type: PERSONAL_SHOPPER_LIST_FAIL_2,
      payload: { error: error },
    });
  }
}

function* threadUser(action) {
  try {
    const { onSuccess, ...otherPayload } = action?.payload || {};
    const response = yield call(API.threadUser, otherPayload);
    if (typeof onSuccess === "function") {
      onSuccess();
    }
    yield put({
      type: THREAD_USER_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: THREAD_USER_FAIL,
      payload: { error: error },
    });
  }
}

function* threadChat(action) {
  try {
    const { onSuccess, ...otherPayload } = action?.payload || {};
    const response = yield call(API.threadChat, otherPayload);
    if (typeof onSuccess === "function") {
      onSuccess();
    }
    yield put({
      type: THREAD_CHAT_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: THREAD_CHAT_SUCCESS_FAIL,
      payload: { error: error },
    });
  }
}


function* personalshopperItemsList(action) {
  try {
    const { onSuccess, ...otherPayload } = action?.payload || {};
    const response = yield call(API.personalShopperItemsList, otherPayload);
    if (typeof onSuccess === "function") {
      onSuccess();
    }
    yield put({
      type: PERSONAL_SHOPPER_ITEMS_LIST_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: PERSONAL_SHOPPER_ITEMS_LIST_FAIL,
      payload: { error: error },
    });
  }
}

function* personalshopperDropDownList(action) {
  try {
    const { onSuccess, ...otherPayload } = action?.payload || {};
    const response = yield call(API.personalShopperDropDownList, otherPayload);
    if (typeof onSuccess === "function") {
      onSuccess();
    }
    yield put({
      type: PERSONAL_SHOPPER_DROP_DOWN_LIST_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: PERSONAL_SHOPPER_DROP_DOWN_LIST_FAIL,
      payload: { error: error }, 
    });
  }
}

function* personalShopperSaga() {
  yield takeLatest(PERSONAL_SHOPPER_LIST_2, personalshopperList);
  yield takeLatest(THREAD_USER, threadUser);
  yield takeLatest(THREAD_CHAT, threadChat);
  yield takeLatest(PERSONAL_SHOPPER_ITEMS_LIST, personalshopperItemsList);
  yield takeLatest(PERSONAL_SHOPPER_DROP_DOWN_LIST, personalshopperDropDownList);
}
export default personalShopperSaga;
